export const TOP_DESTINATIONS = 'interlinkingTopDestinations';
export const TOP_REGIONS = 'interlinkingTopRegions';
export const TOP_TOPICS = 'interlinkingTopTopics';
export const TOP_TOURING_AREAS = 'interlinkingTopTouristicRegions';
